import { render, staticRenderFns } from "./AnnounceAfterServiceHours.vue?vue&type=template&id=652e5e3f&scoped=true"
import script from "./AnnounceAfterServiceHours.vue?vue&type=script&lang=js"
export * from "./AnnounceAfterServiceHours.vue?vue&type=script&lang=js"
import style0 from "./AnnounceAfterServiceHours.vue?vue&type=style&index=0&id=652e5e3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652e5e3f",
  null
  
)

export default component.exports